import PropTypes from 'prop-types';
import React from 'react';
import ResponseForm from './ResponseForm';
import ResponseTestMessage from './ResponseTestMessage';
import SurveyBanner from './SurveyBanner';
import Flash from './Flash';

export const boxTtlClassName = 'fs-24 fw--200 breakword lh-title';

const SurveyResponse = props => {
  return(
    <div>
      <Flash messages={props.flash} />
      <ResponseTestMessage status={props.survey.status} />
      <div style={{minWidth: `calc(${props.survey.response_form_width} + 4rem)`}} className="mxw--50 pos-r z-10 ml-a mr-a fs-14 mt4-m mt5-l">
        <SurveyBanner
          surveyId={props.survey.id}
          attachments={props.attachments}
        />
        <ResponseHeader {...props.survey} />
        <div className="bc-white">
          <div className="srv-page">
            { props.questions[0]._type != 'Survey::EmbeddedDecipher' && <h2 className="c-black-30 ff-bgb fs-18 fw-b lh-title ls-1 mv0 ph4 pt3 tt-u">
              {props.page.name}
            </h2>}
            <ResponseForm {...props} />
          </div>
        </div>
      </div>
    </div>
  )
};

SurveyResponse.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.object),
  flash: PropTypes.object,
  page: PropTypes.object,
  survey: PropTypes.object,
};

SurveyResponse.defaultProps = {
  attachments: [],
};

export default SurveyResponse;

const ResponseHeader = ({ id, name }) => (
  <header>
    <div className={`p4 bc-333 bc1 bg-${id} rounded-top`}>
      <h2 className={`${boxTtlClassName} mv0 c-white ts-black-1`}>{name}</h2>
    </div>
  </header>
);

ResponseHeader.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
};
